import { Card } from 'antd';
import styled from 'styled-components';

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ProfessionalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 18px 20px;
  border-radius: 22px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 14px 32px rgba(18, 62, 51, 0.05);

  .filter-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .filter-label {
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 700;
    color: #5f7f73;
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const CalendarCard = styled(Card)`
  border: 1px solid rgba(24, 90, 66, 0.08) !important;
  border-radius: 24px !important;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 40px rgba(18, 62, 51, 0.06);

  .fc .fc-toolbar-title {
    color: #143d30;
    font-size: 1.2rem;
    letter-spacing: -0.02em;
  }

  .fc .fc-button {
    border-radius: 12px;
    border: none;
    box-shadow: none;
  }

  .fc .fc-button-primary {
    background: #1f725f;
  }

  .fc .fc-button-primary:not(:disabled):hover,
  .fc .fc-button-primary:not(:disabled):active {
    background: #155d4b;
  }

  .fc .fc-daygrid-day-frame,
  .fc .fc-timegrid-slot {
    background: rgba(255, 255, 255, 0.72);
  }
`;
